import { atom } from "jotai";
import { Item } from "../App/App_Store_interface";

const searchQueryAtom = atom('');

const searchResultAtom = atom<Array<Item>>([])

export { searchQueryAtom, searchResultAtom }